function validateEmail(email: string) {
    const filter = /^([a-zA-Z0-9_'&$%#!|~^*.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return filter.test(email ? email.trim() : email);
}

export default validateEmail;
